import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { actions } from '@ui/store/meta';
import { IFocus } from '@ui/store/meta/actions';

export const updateFocus: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.UPDATE_FOCUS),
    switchMap(({ payload }: { payload: IFocus }) => {
      return storeApi
        .updateFocus(payload)
        .pipe(switchMap((response) => of(actions.updateFocusSuccess(response))));
    }),
  );



// WEBPACK FOOTER //
// ./src/store/meta/epics/updateFocus.ts